import ApiHelper from "../../../common/utils/apiHelper";
// helpers
import { isEmailInvalid } from "../../../common/utils/helpers/isEmailInvalid";
import { checkForEmptyField } from "../../../common/utils/helpers/checkForEmptyFields";
import { extractFullNameParts } from "../../../common/utils/helpers/extractFullNameParts";
// actions / selectors
import { globalActionCreators, selectApiBaseUrl } from "../../../common/store/modules/globalModule";
import { confirmationActionCreators } from "../../../common/store/modules/bookingConfirmationModule";

// Toggle mock for Uber initial load
const USE_MOCK_UBER_INITIAL = false;

const MOCK_UBER_INITIAL_RESPONSE = {
  provider_title: "On-demand ride services",
  provider_description:
    "Uber acts solely as an intermediary for the transportation service. Book on-demand rides with upfront pricing and pickup at your hotel address.",
  provider_logo: {
    url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/390c0357-516c-45ae-91b6-152fb9996817/65249b87c14fafd.png",
    name: "Uber"
  },
  items: [
    {
      event_code: "EMXOQYF",
      name: "Uber test offer Zurich",
      booking_setting: {
        customer_name: "mandatory",
        customer_email: "mandatory",
        customer_phone: "mandatory",
        comment: "shown"
      },
      additional_conditions: "https://www.uber.com/legal",
      uber_settings: {
        time_limit: 0,
        additional_terms_and_conditions_label: "DynamicFuture Berlin Terms & Conditions:",
        additional_terms_and_conditions_text:
          'Transportation by DynamicFuture Berlin GmbH --- UBER is solely an intermediary of the transportation service. The contract of transportation arises between the hotel guest and DynamicFuture Berlin GmbH. After clicking "Confirm and Order" we will forward your request to DynamicFuture Berlin GmbH',
        additional_terms_and_conditions_url: "https://safedriver.de/allgemeine-geschaeftsbedingungen/#berlin",
        additional_terms_and_conditions_header: "Uber acts solely as an intermediary for the transportation service",
        additional_terms_and_conditions_image_url: null,
        vehicle_categories: [],
        address: {
          formatted_address: "Gasometerstrasse 9, 8005 Zurich"
        }
      },
      cancellation_policy: "Free cancellation until 5 minutes before pickup. Later cancellations may incur a fee."
    }
  ]
};

export const uberActionTypes = {
  LOAD_UBER_INITIAL: "LOAD_UBER_INITIAL",
  TOGGLE_UBER_INITIAL_ERROR: "TOGGLE_UBER_INITIAL_ERROR",
  SET_UBER_VEHICLE: "SET_UBER_VEHICLE",
  SET_SELECTED_UBER_CAR: "SET_SELECTED_UBER_CAR",
  TOGGLE_UBER_ESTIMATION_ERROR: "TOGGLE_UBER_ESTIMATION_ERROR",
  SET_UBER_BOOKING_ERROR_MESSAGE: "SET_UBER_BOOKING_ERROR_MESSAGE",
  TOGGLE_ESTIMATION_STATE_UBER: "TOGGLE_ESTIMATION_STATE_UBER",
  RESET_UBER_STATE: "RESET_UBER_STATE",
  SET_UBER_DATA_FOR_BOOKING: "SET_UBER_DATA_FOR_BOOKING",
  SET_UBER_BOOKING_RESPONSE_DATA: "SET_UBER_BOOKING_RESPONSE_DATA",
  TOGGLE_UBER_BOOKING_ERROR: "TOGGLE_UBER_BOOKING_ERROR",
  TOGGLE_UBER_PAYMENT_MODAL: "TOGGLE_UBER_PAYMENT_MODAL"
};

export const initialState = {
  uberInitial: null,
  uberInitialItem: null,
  uberVehicle: null, // NOTE: this state will be updated when calling Estimation EP (extended array object)
  uberInitialError: false,
  selectedUberCar: null,
  uberEstimationError: false,
  estimationAvailable: false, // flag which tells us if EP is called & stored on redux // when flag is TRUE, and user changes date/time/route --> flag will be changed to FALSE again
  uberBookingResponseData: null,
  showUberPaymentModal: false,
  uberBookingError: false,
  dataForUberBooking: {
    acceptTerms: false,
    commentForm: "",
    emailForm: "",
    nameForm: "",
    mobileNumberForm: ""
  },
  uberBookingErrorMessage: []
};

const uberModule = (state = initialState, action: any) => {
  switch (action.type) {
    case uberActionTypes.LOAD_UBER_INITIAL: {
      return {
        ...state,
        uberInitial: action.uberInitial,
        uberInitialItem: action.uberInitialItem,
        uberVehicle: action.uberVehicle
      };
    }
    case uberActionTypes.TOGGLE_UBER_INITIAL_ERROR: {
      return {
        ...state,
        uberInitialError: action.uberInitialError
      };
    }
    case uberActionTypes.SET_UBER_VEHICLE: {
      return {
        ...state,
        uberVehicle: action.uberVehicle
      };
    }
    case uberActionTypes.SET_SELECTED_UBER_CAR: {
      return {
        ...state,
        selectedUberCar: action.selectedUberCar
      };
    }
    case uberActionTypes.TOGGLE_UBER_ESTIMATION_ERROR: {
      return {
        ...state,
        uberEstimationError: action.uberEstimationError
      };
    }
    case uberActionTypes.SET_UBER_BOOKING_ERROR_MESSAGE: {
      return {
        ...state,
        uberBookingErrorMessage: action.uberBookingErrorMessage
      };
    }
    case uberActionTypes.TOGGLE_ESTIMATION_STATE_UBER: {
      return {
        ...state,
        estimationAvailable: action.estimationAvailable
      };
    }
    case uberActionTypes.SET_UBER_DATA_FOR_BOOKING: {
      return {
        ...state,
        dataForUberBooking: action.dataForUberBooking
      };
    }
    case uberActionTypes.SET_UBER_BOOKING_RESPONSE_DATA: {
      return {
        ...state,
        uberBookingResponseData: action.uberBookingResponseData
      };
    }
    case uberActionTypes.TOGGLE_UBER_BOOKING_ERROR: {
      return {
        ...state,
        uberBookingError: action.uberBookingError
      };
    }
    case uberActionTypes.TOGGLE_UBER_PAYMENT_MODAL: {
      return {
        ...state,
        showUberPaymentModal: action.showUberPaymentModal
      };
    }
    case uberActionTypes.RESET_UBER_STATE: {
      return {
        ...state,
        // @ts-ignore
        uberVehicle: state?.uberInitialItem?.uber_settings?.vehicle_categories,
        selectedUberCar: null,
        uberEstimationError: false,
        estimationAvailable: false,
        uberBookingResponseData: null,
        uberBookingError: false,
        dataForUberBooking: {
          acceptTerms: false,
          commentForm: "",
          emailForm: "",
          nameForm: "",
          mobileNumberForm: ""
        }
      };
    }
    default:
      return state;
  }
};

export default uberModule;

export const uberActionCreators = {
  getUberInitial: () => async (dispatch: any, getState: any) => {
    const apiUrl = selectApiBaseUrl(getState());

    // turn on the loader
    dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));
    // reset error state
    dispatch({
      type: uberActionTypes.TOGGLE_UBER_INITIAL_ERROR,
      uberInitialError: false
    });

    try {
      let data: any;

      if (USE_MOCK_UBER_INITIAL) {
        await new Promise(resolve => setTimeout(resolve, 250));
        data = MOCK_UBER_INITIAL_RESPONSE;
      } else {
        const res = await ApiHelper.get(`${apiUrl}/transport/uber`);
        data = res.data;
      }

      dispatch({
        type: uberActionTypes.LOAD_UBER_INITIAL,
        uberInitial: data,
        uberInitialItem: data?.items?.[0],
        uberVehicle: data?.items?.[0]?.uber_settings?.vehicle_categories
      });
    } catch (err: any) {
      dispatch({
        type: uberActionTypes.TOGGLE_UBER_INITIAL_ERROR,
        uberInitialError: true
      });
    } finally {
      dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
    }
  },
  setUberTypeOfCar: (selectedUberCar: any) => (dispatch: any) => {
    dispatch({
      type: uberActionTypes.SET_SELECTED_UBER_CAR,
      selectedUberCar
    });
  },
  toggleUberEstimationError: (status: boolean) => (dispatch: any) => {
    dispatch({
      type: uberActionTypes.TOGGLE_UBER_ESTIMATION_ERROR,
      uberEstimationError: status
    });
  },
  toggleUberEstimationAvailableState: (status: boolean) => (dispatch: any) => {
    dispatch({
      type: uberActionTypes.TOGGLE_ESTIMATION_STATE_UBER,
      estimationAvailable: status
    });
  },
  setUberVehicle: (uberVehicle: any) => (dispatch: any) => {
    dispatch({
      type: uberActionTypes.SET_UBER_VEHICLE,
      uberVehicle
    });
  },
  getUberEstimation: (params: any) => async (dispatch: any, getState: any) => {
    // estimation valid state
    dispatch(uberActionCreators.toggleUberEstimationAvailableState(false));
    const apiUrl = selectApiBaseUrl(getState());
    const uberInitialItem = getState().uber.uberInitialItem;

    const apiParams = {
      time: params?.time,
      date: params?.date,
      departureAddress: params?.departureAddress,
      departureAddressId: params?.departureAddressId,
      destinationAddress: params?.destinationAddress,
      destinationAddressId: params?.destinationAddressId
    };
    // turn on the loader
    dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));

    try {
      const res = await ApiHelper.post(`${apiUrl}/transport/uber/${uberInitialItem?.event_code}`, {}, apiParams);

      // reset error state
      dispatch(uberActionCreators.toggleUberEstimationError(false));
      // estimation valid state
      dispatch(uberActionCreators.toggleUberEstimationAvailableState(true));
      // store estimation result
      dispatch(uberActionCreators.setUberVehicle(res?.data?.vehicle_categories));
    } catch (err: any) {
      dispatch(uberActionCreators.toggleUberEstimationError(true));
      // estimation valid state
      dispatch(uberActionCreators.toggleUberEstimationAvailableState(false));
    } finally {
      dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
    }
  },
  resetUberState: () => (dispatch: any) => {
    dispatch({
      type: uberActionTypes.RESET_UBER_STATE
    });
  },
  updateUberFormForBookingAction:
    (dataForUberBooking: {
      acceptTerms: boolean;
      commentForm: string;
      emailForm: string;
      nameForm: string;
      mobileNumberForm: string;
    }) =>
    (dispatch: any) => {
      dispatch({
        type: uberActionTypes.SET_UBER_DATA_FOR_BOOKING,
        dataForUberBooking: dataForUberBooking
      });
    },
  toggleUberBookingErrorAction: (uberBookingError: boolean) => (dispatch: any) => {
    dispatch({
      type: uberActionTypes.TOGGLE_UBER_BOOKING_ERROR,
      uberBookingError
    });
  },
  setUberEstimationErrorMessageAction: (message: any) => (dispatch: any) => {
    dispatch({
      type: uberActionTypes.SET_UBER_BOOKING_ERROR_MESSAGE,
      uberBookingErrorMessage: message
    });
  },
  toggleUberPaymentModalAction: (showUberPaymentModal: boolean) => (dispatch: any) => {
    dispatch({
      type: uberActionTypes.TOGGLE_UBER_PAYMENT_MODAL,
      showUberPaymentModal
    });
  },
  buyUberTicketAction:
    (params: any, navigate: any, setConfirmOrderModalVisible: any) => async (dispatch: any, getState: any) => {
      const dataForUberBookingState = getState().uber.dataForUberBooking;
      const uberInitialItem = getState().uber.uberInitialItem;
      const selectedUberCarState = getState().uber.selectedUberCar;

      // reset booking error message
      dispatch(uberActionCreators.setUberEstimationErrorMessageAction([]));

      // remove bookingResponseDataStorage from the storage, before setting it again
      localStorage.removeItem("bookingResponseDataStorage");

      const apiUrl = selectApiBaseUrl(getState());
      const language = localStorage.getItem("i18nextLng");

      dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));

      const apiParams = {
        summary: {
          start_date: params?.start_date,
          adult: 1,
          timeslot: params?.timeslot,
          offer_code: uberInitialItem?.event_code
        },
        personal_information: {
          first_name: extractFullNameParts(dataForUberBookingState.nameForm)?.firstName,
          last_name: extractFullNameParts(dataForUberBookingState.nameForm)?.lastName,
          email: dataForUberBookingState.emailForm,
          phone: dataForUberBookingState.mobileNumberForm,
          comment: dataForUberBookingState.commentForm ? dataForUberBookingState.commentForm : null
        },
        hotel_stay_code: getState().tenant.tenantInfo?.code,
        extraBookingData: {
          sendBookingConfirmationCopy: true,
          productId: selectedUberCarState?.product_id,
          fareId: selectedUberCarState?.price?.fare_id,
          category: selectedUberCarState?.category,
          departureAddress: params?.departureAddress,
          departureAddressId: params?.departureAddressId,
          destinationAddress: params?.destinationAddress,
          destinationAddressId: params?.destinationAddressId,
          additional_conditions: dataForUberBookingState.acceptTerms
        }
      };

      try {
        const response = await ApiHelper.post(`${apiUrl}/bookings`, {}, apiParams);

        localStorage.setItem("bookingResponseDataStorage", JSON.stringify(response.data));

        // We can get API status 200, with booking_status=error --> in that case we should show error page instead of Payment Modal / Confirmation Page
        if (response.data?.booking_status === "error") {
          dispatch(uberActionCreators?.toggleUberBookingErrorAction(true));
          return;
        } else {
          dispatch(uberActionCreators?.toggleUberBookingErrorAction(false));

          dispatch({
            type: uberActionTypes.SET_UBER_BOOKING_RESPONSE_DATA,
            uberBookingResponseData: response.data
          });

          // If price is 0 we will get payment_status=paid from API --> and we should redirect user directly to the /confirmation page (without payment modal)
          if (response.data?.payment_status === "paid") {
            // call booking status action, in order to set new value to the bookingStatus state
            await dispatch(confirmationActionCreators?.getBookingStatusAction());
            // redirect to confirmation
            await navigate(`/${language}/transport/uber/confirmation`, { replace: true });
          } else {
            // open payment modal (if status is not booked)
            dispatch(uberActionCreators?.toggleUberPaymentModalAction(true));
          }
        }
      } catch (err: any) {
        if (err?.response?.data?.fields) {
          dispatch(uberActionCreators.setUberEstimationErrorMessageAction(err?.response?.data?.fields));
        }

        dispatch(uberActionCreators?.toggleUberBookingErrorAction(true));
      } finally {
        dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
        setConfirmOrderModalVisible(false);
      }
    },
  handleBookARideAction: (setConfirmOrderModalVisible: any) => (dispatch: any, getState: any) => {
    const dataForUberBookingState = getState().uber.dataForUberBooking;
    const uberInitialItem = getState().uber.uberInitialItem;

    dispatch(uberActionCreators?.toggleUberBookingErrorAction(false));

    let errorField = {
      emailForm: false,
      commentForm: false,
      nameForm: false,
      mobileNumberForm: false,
      acceptTerms: false
    };
    let errorCheck = true;

    if (
      isEmailInvalid(dataForUberBookingState.emailForm) ||
      (checkForEmptyField(dataForUberBookingState.emailForm) &&
        uberInitialItem?.booking_setting?.customer_email === "mandatory")
    ) {
      errorField.emailForm = true;
      errorCheck = false;
    }

    if (
      (uberInitialItem?.booking_setting?.comment === "mandatory" &&
        checkForEmptyField(dataForUberBookingState.commentForm)) ||
      (dataForUberBookingState?.commentForm !== "" && dataForUberBookingState?.commentForm?.length < 3)
    ) {
      errorField.commentForm = true;
      errorCheck = false;
    }

    if (
      uberInitialItem?.booking_setting?.customer_name === "mandatory" &&
      checkForEmptyField(dataForUberBookingState.nameForm)
    ) {
      errorField.nameForm = true;
      errorCheck = false;
    }

    if (
      uberInitialItem?.booking_setting?.customer_phone === "mandatory" &&
      checkForEmptyField(dataForUberBookingState.mobileNumberForm)
    ) {
      errorField.mobileNumberForm = true;
      errorCheck = false;
    }

    if (!dataForUberBookingState.acceptTerms) {
      errorField.acceptTerms = true;
      errorCheck = false;
    }

    if (!errorCheck) {
      dispatch({ type: "TOGGLE_ERROR_FIELD", errorExists: true, errorField: errorField });
      setConfirmOrderModalVisible(false);
    } else {
      dispatch({ type: "TOGGLE_ERROR_FIELD", errorExists: false, errorField: errorField });
      setConfirmOrderModalVisible(true);
    }
  }
};
